import {Circle} from 'react-konva';
import {KonvaEventObject} from 'konva/types/Node';
import React, {useCallback, useMemo} from 'react';

import {Point} from './types';

type ShadowProps = {
  color: string;
  blur: number;
  offsetX?: number;
  offsetY?: number;
  opacity?: number;
};

export type AnchorPointProps = {
  point: Point;
  fill: string;
  radius?: number;
  strokeColor?: string;
  strokeWidth?: number;
  shadow?: ShadowProps;
  onClick?: () => void;
  onMouseOut?: () => void;
  onMouseOver?: () => void;
};

const DEFAULT_PROPS = {
  radius: 10,
  strokeColor: '#668',
  strokeWidth: 2,
};

export function AnchorPoint({
  point,
  fill,
  radius = DEFAULT_PROPS.radius,
  strokeColor = DEFAULT_PROPS.strokeColor,
  strokeWidth = DEFAULT_PROPS.strokeWidth,
  shadow,
  onClick,
  onMouseOut,
  onMouseOver,
}: AnchorPointProps) {
  const shadowProps = useMemo(() => {
    let shadowResult = {};

    if (shadow) {
      shadowResult = {
        shadowBlur: shadow.blur,
        shadowColor: shadow.color,
        shadowOpacity: shadow.opacity,
        shadowOffset: {x: shadow.offsetX || 0, y: shadow.offsetY || 0},
      };
    }

    return shadowResult;
  }, [shadow]);

  const handleMouseOver = useCallback(() => {
    document.body.style.cursor = 'pointer';
    onMouseOver?.();
  }, [onMouseOver]);

  const handleMouseOut = useCallback(() => {
    document.body.style.cursor = 'default';
    onMouseOut?.();
  }, [onMouseOut]);

  const handleClick = useCallback(
    (event: KonvaEventObject<MouseEvent>) => {
      event.cancelBubble = true;
      event.evt.stopPropagation();
      onClick?.();
    },
    [onClick]
  );

  return (
    <Circle
      x={point.x}
      y={point.y}
      fill={fill}
      radius={radius}
      {...shadowProps}
      name="anchor-point"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    />
  );
}
